export default "__VITE_ASSET__B_eiIr82__"